export const CLIENT_EMPTY_STATE_LEARN_MORE =
  'https://support.copilot.com/hc/en-us/articles/6361758427675-How-do-I-create-and-invite-my-clients-';

export const MESSAGE_CHANNEL_EMPTY_STATE_LEARN_MORE =
  'https://support.copilot.com/hc/en-us/sections/6342849373083-Messaging';

export const FILE_CHANNEL_EMPTY_STATE_LEARN_MORE =
  'https://support.copilot.com/hc/en-us/sections/10039900945691-Files';

export const FORMS_EMPTY_STATE_LEARN_MORE =
  'https://support.copilot.com/hc/en-us/sections/10039924463259-Forms';

export const INVOICES_EMPTY_STATE_LEARN_MORE =
  'https://support.copilot.com/hc/en-us/articles/6641363256859-How-can-I-create-an-invoice-';

export const SUBSCRIPTION_EMPTY_STATE_LEARN_MORE =
  'https://support.copilot.com/hc/en-us/articles/6641414563227-How-can-I-create-a-subscription-';

export const KNOWLEDGE_BASE_EMPTY_STATE_LEARN_MORE =
  'https://support.copilot.com/hc/en-us/sections/10039926207771-Knowledge-Base';
